/**
 * Feature Flags Configuration
 *
 * Control feature rollouts and migrations
 */

export const FEATURE_FLAGS = {
  // Dynamic Product Configuration Migration
  // Set to true to enable dynamic configuration from backend
  // Set to false to use legacy hardcoded configuration
  ENABLE_DYNAMIC_PRODUCT_CONFIG: true,

  // New Response Structure Migration
  // Set to true when backend returns new structure: { data: { ...fields, documents: [...] } }
  // Set to false to use current backend response structure
  ENABLE_NEW_RESPONSE_STRUCTURE: true,

  // Dummy Response Mode
  // Set to true to use dummy/mock API responses for testing without backend
  // Set to false to call actual backend API
  USE_DUMMY_RESPONSE: false,

  // Maintenance Mode
  // Set to true to show maintenance warnings and disable registration/try-now features
  APPLICATION_UNDER_MAINTENANCE: false,

  // Block Registration during Maintenance
  // Set to true to prevent users from registering when maintenance mode is on
  BLOCK_REGISTRATION_DURING_MAINTENANCE: false,

  // Other feature flags can be added here
  // ENABLE_NEW_UI: false,
  // ENABLE_ANALYTICS: true,
};

/**
 * Check if a feature is enabled
 * @param {string} featureName - Name of the feature flag
 * @returns {boolean}
 */
export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] || false;
};
